import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { BoothService } from '../../services/booth.service';
import { BoothSyncService } from '../../services/booth-sync.service';
import { PairingService } from '../../services/pairing.service';

@Component({
    selector: 'app-admin-modal',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './admin-modal.component.html'
})
export class AdminModalComponent {
  booth   = inject(BoothService);
  sync    = inject(BoothSyncService);
  pairing = inject(PairingService);
  router  = inject(Router);

  // Two-tap confirmation, same pattern used on the TV's "New booth" control.
  confirmingUnsync = signal(false);
  private confirmTimeout: ReturnType<typeof setTimeout> | null = null;

  close() {
    this.booth.showAdmin.set(false);
    this.cancelUnsyncConfirm();
  }

  /** First tap arms the confirmation; second tap (within 4s) actually unsyncs. */
  onUnsyncTap() {
    if (!this.confirmingUnsync()) {
      this.confirmingUnsync.set(true);
      this.confirmTimeout = setTimeout(() => this.cancelUnsyncConfirm(), 4000);
      return;
    }
    this.unsyncBooth();
  }

  private cancelUnsyncConfirm() {
    this.confirmingUnsync.set(false);
    if (this.confirmTimeout) { clearTimeout(this.confirmTimeout); this.confirmTimeout = null; }
  }

  /** Disconnects this iPad from its current booth pairing. Notifies the TV
   *  instantly via 'pairing.reset' so it drops back to a fresh QR code, then
   *  sends this device to /pair (no ?session=) — which shows "Device not
   *  synced, scan the new QR" instead of the Home screen, since Home implies
   *  an active pairing that no longer exists. */
  private async unsyncBooth() {
    this.cancelUnsyncConfirm();
    const uuid = this.pairing.getSavedIpadUuid();

    if (uuid) {
      try { await this.pairing.reset(uuid); } catch { /* best-effort */ }
    }

    this.pairing.stopHeartbeatLoop();
    this.pairing.clearIpadUuid();
    this.sync.disconnect();

    this.booth.showAdmin.set(false);

    this.router.navigate(['/pair']);
  }
}
